module.exports = __webpack_public_path__ + "static/img/z-2.43ee57a0.png";